import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { HomeImageService } from '../../services/home-image.service';
import { HomeImageModel } from '../../models/home-image.model';
import { HomeSectionModel } from '../../models/home-section.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-middle-banner',
  templateUrl: './middle-banner.component.html',
  styleUrls: ['./middle-banner.component.scss']
})
export class MiddleBannerComponent implements OnInit, OnDestroy {
  /** Presentation configured for the middle-banner section in the admin home-page settings. */
  @Input() section: HomeSectionModel;

  isRtl: boolean = true;
  mediaUrl: string = environment.homeImageResource;
  middleBanner: HomeImageModel = {} as HomeImageModel;
  private destroySubject: Subject<void> = new Subject();

  constructor(private homeImageService: HomeImageService, private languageService: LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit(): void {
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange.subscribe((result: LanguageEnum) => (this.isRtl = result === LanguageEnum.ar));
    this.homeImageService.GetMiddleBannerImages()
    .pipe(takeUntil(this.destroySubject))
    .subscribe((result: HomeImageModel[]) => this.middleBanner = result?.[0] ?? {} as HomeImageModel);
  }

  // E2E-ISSUE-030 / US-167 S3: the configured presentation wins. The section title/description
  // (home-page settings) comes first, then the banner image's own bilingual caption, and only when
  // nothing is configured does the generic platform copy show.
  get title(): string {
    return this.section?.title?.trim()
      || (this.isRtl ? this.middleBanner?.titleAr : this.middleBanner?.title)
      || '';
  }

  get description(): string {
    return this.section?.description?.trim()
      || (this.isRtl ? this.middleBanner?.detailsAr : this.middleBanner?.details)
      || (this.isRtl ? this.middleBanner?.subTitleAr : this.middleBanner?.subTitle)
      || '';
  }

  get image(): string {
    const configured = this.section?.image || this.middleBanner?.imagePath;
    return configured ? this.mediaUrl + configured : 'assets/imgs/middle-banner-bg.svg';
  }

  ngOnDestroy(): void {
    this.destroySubject.next()
  }
}
